import { UserProfile } from 'api/account/models/UserProfile';
import { UserToken } from 'api/account/models/UserToken';

export const SET_AUTHENTICATION = 'SET_AUTHENTICATION';
export const SET_PROFILE = 'SET_PROFILE';
export const UPDATE_REFRESH_TOKEN = 'UPDATE_REFRESH_TOKEN';
export const SET_COMPANY_INFO_FILLED = 'SET_COMPANY_INFO_FILLED';
export const SET_POLICIES_CHANGED = 'SET_POLICIES_CHANGED';
export interface Action {
    type: string;
    [propName: string]: any;
}

export interface AuthenticationState {
	isAuthenticated: boolean;
    token: UserToken | null;
    profile: UserProfile | null;
    refreshToken: number;
    isCompanyInfoFilled: boolean;
    policiesChanged: boolean;
}
